import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTheme } from "hooks";
import { StringHelper } from "utils";

function InformationRow({ titulo, informacion, descripcion = false }) {
    const { theme } = useTheme();
    
    // Función helper para renderizar contenido seguro
    const renderContent = (content) => {
        if (typeof content === 'string' || typeof content === 'number') {
            return content;
        }
        if (typeof content === 'boolean') {
            return content.toString();
        }
        if (content === null) {
            return 'null';
        }
        if (typeof content === 'object') {
            return JSON.stringify(content);
        }
        return String(content);
    };

    return (
        <div className="mt-0 mr-3 mb-0 ml-3">
            <div
                className="m-0 text-muted"
                style={{
                    width: "100%",
                    fontSize: "1.8vh",
                    fontFamily: `Roboto,Helvetica Neue,Arial,sans-serif`, 
                    fontWeight: 400,
                }}
            >
                {titulo}
            </div>
            <div
                className="m-0 text-wrap"
                style={{
                    width: "100%",
                    fontSize: "1.8vh",
                    fontFamily: `Roboto,Helvetica Neue,Arial,sans-serif`,
                    fontWeight: 400,
                    overflowWrap: "break-word",
                }}
            >
                {informacion !== undefined ? (
                    descripcion && Array.isArray(informacion) && informacion.length ? (
                        // Caso: descripcion = true e informacion es array
                        informacion.map((el, i) => {
                            return (
                                <div key={el?.IdSec || i}>
                                    {typeof el === "string"
                                        ? StringHelper.cutLetter(el, 400, "...")
                                        : renderContent(el)}
                                </div>
                            );
                        })
                    ) : (
                        // Caso: descripcion = false o informacion no es array
                        <>{renderContent(informacion)}</>
                    )
                ) : (
                    <Skeleton baseColor={theme.skeletonColor} />
                )}
            </div>
        </div>
    );
}

export default InformationRow;